import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { API } from "aws-amplify";
import ModalAR from "../Pages/wizard/FormElements/ModalAR";
import ModalErrores from "../Pages/wizard/FormElements/ModalErrores";
import { formatNumber } from "../Utils/utils";
import { validateOnlyAlphanumeric, validateOnlyNumbers } from "../Utils/validators";
import { defaultFormShape } from "../Utils/constants";

import CardAprobar from "../Components/FormElements/CardAprobar";
import { modalSteps } from "../Store/simulate/actions";
import { quoteDataModal } from "../Store/quote/actions";
import TitleHeader from "./titleHeader";
import Loading from "../Components/loading";
import Step from "../Components/FormElements/step";
import useBeforeFirstRender from "../customHook/useBeforFirstRenderQuote";
import ModalRejectQuote from "../Components/modalRejectQuote";
import ModalMessage from "../Components/modalMessage";
import ModalAttach from "../Components/modalAttach";
import img from "../Resources/img/image-user-2.jpg";
import check from "../Resources/svg/check.svg";
import error from "../Resources/svg/error.svg";
import IconWarning40 from "../Resources/svg/Icons/IconAlert";
import IconAdjuntar from "../Resources/svg/Icons/IconAdjuntar";

import {
  cardProducts,
  getTitleCase,
} from "../Utils/simulaciones/simulaciones";

export default function VerifyQuote() {
  const data = useSelector((state) => state.quote.policy.client);
  const quote = data.datosCotizacion;
  const client = data.datosCliente;
  const history = useHistory();

  const dispatch = useDispatch();
  const clientData = client ? client.datosParticulares : null;
  const beneficiary = client ? client.beneficiarios.personalizados : null;
  let cardCoti = [];
  let tramaCoti = [];
  const location = useLocation();
  const dataLocation = location.state;
  const [tipoModal, setTipoModal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openModalReject, setOpenModalReject] = useState(false);
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [typeMessage, setTypeMessage] = useState("");
  const [idAE, setIdAE] = useState(null);

  const [code, setCode] = useState("");
  const [ typeCode, setTypeCode] = useState();
  const [openModalAttach, setOpenModalAttach] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [dataModal, setDataModal] = useState({
    status: false,
    message: "",
  });
  const [cotiData, setCotiData] = useState({});
  const handleOpenModalAttach = (data) => {
    setOpenModalAttach(true);
    document.body.style.overflow = "hidden";
    setCotiData(data);
  };

  const validateData = true ? dataLocation : cotiData;

  const handleChange = (e) => {
    setDisabledButton(true);
    if (validateOnlyAlphanumeric(e.target.value)) {
      setDisabledButton(false);
    }

    setCode(e.target.value)
  };

  const handleChangeRG = (e) => {
    setDisabledButton(true);
    if (validateOnlyNumbers(e.target.value)) {
      setDisabledButton(false);
      
    }
    setCode(e.target.value)
  };

  const navigationPrev = () => {
    history.push("/aprobaciones");
  };

  useBeforeFirstRender(client);
  const approveQuote = async () => {
    setIsLoading(true);
    const request = {
      body: {
        idCotizacion: data.idCotizacion,
        codigoRecaudo: code,
      },
    };

    

    const response = await API.post("api-rentas", "/suscription", request);

    setIsLoading(false);
    setOpen(true);
    if (response.status) {
      setDataModal({
        ...dataModal,
        status: true,
        message: "Se aprobó la cotización correctamente",
      });
      setIdAE(response.data.POLIZA.NUMPOLAS);
    } else {
      setDataModal({
        ...dataModal,
        status: false,
        message: response.message,
      });
    }
  };

  const rejectQuote = () => {
    setOpenModalReject(true);
  };

  const processRejectQuote = async (values) => {
    const params = {
      quoteId: data.idCotizacion,
      ...values,
    };

    setIsLoading(true);
    const response = await API.post("api-rentas", "/reject-quote", {
      body: params,
    });
    if (response.status) {
      setTypeMessage("success");
      setMessage(`La cotización ha sido rechazada.`);
    } else {
      setTypeMessage("error");
      setMessage(`Error al tratar de rechazar la cotización.`);
    }
    setIsLoading(false);
    setOpenModalMessage(true);
  };


  const onSubmit = async (e) => {
      setReduxModal();
      setTipoModal("Aprobar");
      dispatch(modalSteps(true));
      e.preventDefault();
    };
  
  const rechazarCotizacion = () => {
    setReduxModal();
    setTipoModal("Rechazar");
    dispatch(modalSteps(true));
  };

  const setReduxModal = () => {

      let request = {
        body: {
          idCotizacion: data.idCotizacion,
          [typeCode]: code
        },
      };
      dispatch(quoteDataModal(request));
    };

  if (client) {
    const nameCli = clientData.names;
    const ApeCli = clientData.firstName.concat(" ", clientData.lastName);

    const firstName = nameCli ? getTitleCase(nameCli) : "";

    const lastName = ApeCli ? getTitleCase(ApeCli) : "";

    const sexCli = clientData.sexo === "F" ? "Femenino" : "Masculino";

    const urbanization = clientData.address.urbanization
      ? `, Urb. ${clientData.address.urbanization}`
      : clientData.address.urbanization;
    const dirCli = clientData.address.type.concat(
      ". ",
      clientData.address.name,
      ", ",
      clientData.address.number,
      " ",
      urbanization,
      ", ",
      clientData.address.nameUbigeo.district
    );
    let herederos = [];
    if (beneficiary.length > 0 && beneficiary[0].nombres !== "") {
      beneficiary.map((heredero) =>
        herederos.push({
          nombre: heredero.nombres,
          apellido: heredero.apePaterno.concat(" ", heredero.apeMaterno),
          tipoDoc: heredero.tipoDoc,
          dni: heredero.documento,
          fecNacimiento: heredero.fecNacimiento,
          sexo: heredero.sexo === "F" ? "Femenino" : "Masculino",
          relacion: heredero.relacion,
          beneficio: heredero.porcentaje,
        })
      );
    }
    cardCoti = cardProducts(
      data,
      tramaCoti,
      firstName,
      lastName,
      clientData,
      sexCli,
      dirCli,
      herederos
    );
  }

  const hideInput =
    data.estado === "rechazada" || data.estado === "vencida"
      ? "d-none"
      : "d-show";

  return (
    <div className="container">
      <div className="dataVerification">
        <div className="column">
          <Step handleClick={() => navigationPrev()} step="1" total="1" />
          <TitleHeader
            title="Verificación de"
            titleBold="datos"
            subtitle="Revisemos que los datos ingresados sean los correctos"
          />

            {cardCoti.map((coti, index) => (
                <CardAprobar key={index} loading={false} data={coti} />
              ))}
          { data.producto.codigo === 'RG' ? (<>
          {
                         
                         data.estado === 'firmado' &&(
                          <div className="card-verify">
                          <div className="card-verify__body">
                          <div className="card-verify__adjuntar">
                            <div className="box">
                              <div className="box__icon">
                                <IconWarning40 />
                              </div>
                              <div className="box__text">
                                Si el cliente pagó sin usar el código, deberás adjuntar el
                                voucher.
                                <div
                                  className="box__click"
                                  onClick={() => handleOpenModalAttach()}
                                >
                                  <IconAdjuntar /> <span>Adjuntar</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                          </div>
                        )}
            { data.estado !== 'firmado' && data.estado !== 'rechazada' && data.estado !== 'errEmitida' && data.estado !== 'emitida' && data.estado !== 'enFila' && (<>
              <div >
                <div className="adForm-container ">
                <div className="product-view">
                <div className="wapperGetClient__group">
                  <div className="wapperGetClient__group__item-rg">
                    <label>
                      <input
                        name={`checkbox1`}
                        className="filled-in"
                        type="checkbox"
                        value={'codigoRecaudo'}
                        checked={typeCode === 'codigoRecaudo' ? true : null}
                        onChange={(e) => setTypeCode(e.target.value)}
                      />
                      <span className="checkbox-name">
                        Relación de ingreso (RI)
                      </span>
                    </label>
                  </div>
                  <div className="wapperGetClient__group__item-rg">
                    <label>
                      <input
                        name={`LPDP`}
                        className="filled-in"
                        type="checkbox"
                        value={'numObligacion'}
                        checked={typeCode === 'numObligacion' ? true : null}
                        onChange={(e) => setTypeCode(e.target.value)}
                      />
                      <span className="checkbox-name">
                      Número de obligación
                      </span>
                    </label>
                  </div>
              </div>
                </div>
               
                </div>
              
                { typeCode && <div
                  className={
                    "clientForm__control input-field" +
                    (false ? " is-fill" : "")
                  }
                >
                  <input
                    id="recaudo"
                    type="text"
                    name="recaudo"
                    autoComplete="off"
                    value={code}
                    disabled={!typeCode}
                    onChange={(e) => handleChangeRG(e)}
                  />
                  <label htmlFor="recaudo">{ typeCode === 'codigoRecaudo' ? 'Ingresar RI  ' : 'Ingresar Obligación'}</label>
                </div>}</div>
              <div className="content-button-reject">
            <a onClick={() => rechazarCotizacion()} className="btn-flat reject">
              Rechazar cotización
            </a>
          </div>
          <div className='content-buttons dataVerification'>
            <button
              disabled={ disabledButton ? true : false}
              type="button"
              className="buttonCustom md"
              onClick={() => onSubmit()}
            >
              Aprobar
            </button>
          </div></>)}</>) : (<>
            <div className={hideInput}>
                <div
                  className={
                    "clientForm__control input-field" +
                    (false ? " is-fill" : "")
                  }
                >
                  <input
                    id="recaudo"
                    type="number"
                    name="recaudo"
                    autoComplete="off"
                    onChange={(e) => handleChange(e)}
                  />
                  <label htmlFor="recaudo">Ingresar código de recaudo:</label>
                </div></div>
            <div className="content-button-reject">
            <a onClick={() => rechazarCotizacion()} className="btn-flat reject">
              Rechazar cotización
            </a>
          </div>
          <div className='content-buttons dataVerification'>
            <button
              disabled={ disabledButton ? true : false}
              type="button"
              className="buttonCustom md"
              onClick={() => onSubmit()}
            >
              Aprobar
            </button>
          </div>
            
          </>)}
        </div>
        <div className="column-image">
          <img src={img} />
        </div>
      </div>
      <div className={`modalCustom ${open ? "is-open" : ""}`}>
        <div className="modalCustom__container">
          <img
            src={dataModal.status ? check : error}
            alt="image"
            className="modalCustom__container__image"
          />
          <div className="modalCustom__container__message">
            {dataModal.message}
          </div>
          {idAE && (
            <div className="modalCustom__container__message">{idAE}</div>
          )}
          <button
            type="button"
            className="buttonCustom sm"
            onClick={() =>
              dataModal.status ? navigationPrev() : setOpen(false)
            }
          >
            <span>{dataModal.status ? "Ir a cotizaciones" : "Cerrar"}</span>
          </button>
        </div>
      </div>
      <ModalErrores />
      <ModalAR
        type={tipoModal}
        quoteData={{producto: {codigo: data.producto.codigo}}}
        numCotizacion={data.numCotizacion}
        moneda={quote.moneda}
      />
      <ModalMessage
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        message={message}
        type={typeMessage}
        callbackClosed={navigationPrev}
      />
      <ModalAttach
        data={data}
        open={openModalAttach}
        setOpen={setOpenModalAttach}
      />
      {isLoading && <Loading  />}
    </div>
  );
}
